export default function (state = null, action) {
    switch (action.type) {
        case 'ROLE_TOGGLE':
            return action.payload;
        default:
            return state;
    }
}